<template>
<b-row>
  <b-col md="3" sm="12">
    <div class="form-group">
      <label class="form-control-label">{{ $t('views.excmnotificationmessage.form.description') }}:</label>
      <input v-model.lazy="filters.descriptionFilter" v-debounce="delay" class="form-control" type="text" placeholder="">
    </div>
  </b-col>
  <b-col md="2" sm="12">
    <b-form-group>
      <label>{{$t('views.excmrelation.show.dateFrom')}}:</label>
      <VueCtkDateTimePicker no-header
                            :label="$t('views.excmrelation.show.dateFrom')"
                            v-model.lazy="filters['paymentDate[after]']"
                            v-debounce="delay"
                            format="YYYY-MM-DD"
                            :onlyDate="true"
                            :right="true"
                            formatted="ll"
      >
      </VueCtkDateTimePicker>
    </b-form-group>
  </b-col>
  <b-col md="2" sm="12">
    <b-form-group>
      <label>{{$t('views.excmrelation.show.dateTo')}}:</label>
      <VueCtkDateTimePicker no-header
                            :label="$t('views.excmrelation.show.dateTo')"
                            v-model.lazy="filters['paymentDate[before]']"
                            v-debounce="delay"
                            format="YYYY-MM-DD"
                            :onlyDate="true"
                            :right="true"
                            formatted="ll"
      >
      </VueCtkDateTimePicker>
    </b-form-group>
  </b-col>
  <b-col sm="2" md="2">
    <div class="form-group">
      <label class="form-control-label">{{ $t('views.exsbpaymentsmade.list.invoice') }}:</label><br>
      <base-select-input
        v-model="filters.idEXSBInvoice"
        :search-callback="invoiceSearchCallback"
        :get-processed-text-custom="getInvoiceProcessedText"
        :display-values="['number']"
        :query-param="'number'"
        :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
      ></base-select-input>
    </div>
  </b-col>
  <b-col sm="2" md="2">
    <div class="form-group">
      <label class="form-control-label">{{ $t('views.exsbpaymentsmade.list.idUserDataToInvoice') }}:</label><br>
      <base-select-input
        required
        v-model="filters['idEXSBInvoice.idUserData']"
        :search-callback="userDataSearchCallback"
        :query-param="'userdata'"
        :display-values="['fullName', 'firmname1']"
        :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
      ></base-select-input>
    </div>
  </b-col>
  <b-col sm="2" md="3">
    <div class="form-group">
      <label class="form-control-label">{{ $t('views.exsbpaymentsmade.list.idBankPackage') }}:</label>
      <b-form-group>
        <b-form-radio-group
          v-model="filters.bankPayment"
          :options="bankPackageOptions"
          buttons
          button-variant="outline-primary"
          name="radios-btn-default"
        ></b-form-radio-group>
      </b-form-group>
    </div>
  </b-col>
  <b-col sm="" md="3">
    <div class="form-group">
      <label class="form-control-label">{{ $t('views.exsbpaymentsmade.list.idEXSBInvoice') }}:</label>
      <b-form-group>
        <b-form-radio-group
          v-model="filters.invoice"
          :options="bankPackageOptions"
          buttons
          button-variant="outline-primary"
          name="radios-btn-default"
        ></b-form-radio-group>
      </b-form-group>
    </div>
  </b-col>
</b-row>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import debounce from 'v-debounce'
import addParamsToQuery from '@/utils/addParamsToQuery'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'
import ApiService from '@/utils/ApiService'
export default {
  name: 'PaymentMadeFiltering',
  components: {
    BaseSelectInput,
    VueCtkDateTimePicker
  },
  directives: {
    debounce
  },
  data () {
    return {
      filters: this.$store.state.filters.paymentsMadeFilter,
      delay: 500,
      bankPackageOptions: [
        { value: 0, text: this.$t('global.all') },
        { value: 1, text: this.$t('global.yes') },
        { value: 2, text: this.$t('global.no') }
      ]
    }
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        this.$store.state.filters.paymentsMadeFilterCurrentPage = 1
        let url = 'e_x_s_b_payments_mades'
        let params = JSON.parse(JSON.stringify(this.filters))
        if (params.bankPayment === 1) {
          params['idBankPayment[exists]'] = true
        } else if (params.bankPayment === 2) {
          params['idBankPayment[exists]'] = false
        }
        params.bankPayment = undefined
        if (params.invoice === 1) {
          params['idEXSBInvoice[exists]'] = true
        } else if (params.invoice === 2) {
          params['idEXSBInvoice[exists]'] = false
        }
        params.invoice = undefined
        this.getPage(addParamsToQuery(url, params))
      }
    }
  },
  methods: {
    getPage (url) {
      this.$emit('getPage', url)
    },
    clearFilters () {
      this.filters = Object.assign(this.filters, this.$store.state.filters.paymentsMadeFilterReference)
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false, isCompany: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    async invoiceSearchCallback (params = {}) {
      let baseParams = { pagination: false, accepted: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_s_b_invoices', baseParams).getResults()
      return response.items
    },
    getInvoiceProcessedText (entry) {
      let textData = entry.buyerName + ' / '
      if (entry.nip) {
        textData += entry.nip + ' / '
      }
      textData += entry.number + ' (' + this.$t('views.exsbinvoices.show.toPay') + ': ' + entry.toPay + ' / ' +
        this.$t('views.exsbinvoices.form.invoiceValue') + ': ' + entry.totalValueBrutto + ')'
      return textData
    }
  }
}

</script>

<style scoped>

</style>
